module.exports = __webpack_public_path__ + "img/__icon_CIĄGNIK_SIODŁOWY.dc6886f3.svg";